__turbopack_context__.v({
  "back": "CategoryBanner-module__KBowwW__back",
  "banner": "CategoryBanner-module__KBowwW__banner",
  "description": "CategoryBanner-module__KBowwW__description",
  "fullbanner": "CategoryBanner-module__KBowwW__fullbanner",
  "heading": "CategoryBanner-module__KBowwW__heading",
});
